export const loginValidation = (email, password) => {
  const isEmailValid = /@[^.]*\./.test(email);
  const isPasswordValid =
  // eslint-disable-next-line
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
      password
    );

  if (!isEmailValid) return "Email is not valid";
  if (!isPasswordValid)
    return "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character";

  return null;
};

export const registerValidation = (email, password, confirmPassword) => {
  const isEmailValid = /@[^.]*\./.test(email);
  const isPasswordValid =
  // eslint-disable-next-line
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
      password
    );

  if (!isEmailValid) return "Email is not valid";
  if (!isPasswordValid)
    return "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character";
    if (password !== confirmPassword) 
    return "Confirm password does not match";

  return null;
};
